import {Ability} from '@casl/ability'
import {initialAbility} from './config'

export default new Ability(initialAbility)
